import parallel from 'async/parallel'
riot.tag2('product-edit-options', '  <div class="row">\n    <div class="col-md-12">\n      <div class="form-inline m-b-3">\n        <div class="form-group">\n          <button class="btn btn-primary" type="button" onclick="{addOption}"><i class="fa fa-plus"></i> Добавить опции</button>\n          <yield to="toolbar">\n            <yield from="toolbar"></yield>\n          </yield>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <ul class="nav nav-tabs m-b-2" if="{value.length &gt; 0}">\n        <li class="{active: activeTab === i}" each="{item, i in value}"><a onclick="{changeTab}"><span>{item.name}</span>\n            <button class="close" onclick="{closeTab}" type="button"><span>&times;</span></button></a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <product-edit-option-values if="{value.length &gt; 0}" value="{value[activeTab]}" modifications="{opts.modifications}"></product-edit-option-values>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;
self.modifications = [];

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value;
    },
    set: function set(value) {
        self.value = value;
        self.update();
    }
});

self.activeTab = 0;

self.changeTab = function (e) {
    self.activeTab = e.item.i;
};

self.closeTab = function (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    self.value = self.value.slice(0, self.value.length);
    self.value.splice(e.item.i, 1);

    if (e.item.i <= self.activeTab) if (self.activeTab > 0) self.activeTab -= 1;

    var event = document.createEvent('Event');
    event.initEvent('change', true, true);
    self.root.dispatchEvent(event);
};

self.addOption = function () {
    modals.create('product-edit-options-select-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        beforeSuccess: function beforeSuccess(response, xhr) {
            if (self.value && self.value instanceof Array && self.value.length > 0) {
                (function () {
                    var ids = self.value.map(function (item) {
                        return item.id;
                    });
                    var items = response.items.filter(function (item) {
                        return ids.indexOf(item.id) === -1;
                    });

                    response.items = items;
                })();
            }
        },
        submit: function submit() {
            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            if (items.length > 0 && !(self.value instanceof Array)) self.value = [];

            items = items.map(function (item) {
                item.columns = [{ id: item.id, name: item.name }];
                item.items = [];
                return item;
            });

            self.value = self.value.concat(items);

            var event = document.createEvent('Event');
            event.initEvent('change', true, true);
            self.root.dispatchEvent(event);
            this.modalHide();
        }
    });
};

self.on('update', function () {
    if (opts.modifications) self.modifications = opts.modifications;
    if (opts.value) self.value = opts.value;

    if (opts.name) self.root.name = opts.name;
});
});
riot.tag2('product-edit-option-values', '  <div class="form-inline m-b-3">\n    <div class="form-group">\n      <button class="btn btn-primary" type="button" onclick="{addValue}"><i class="fa fa-plus"></i> Добавить</button>\n    </div>\n    <div class="form-group">\n      <button class="btn btn-danger" if="{selectedCount}" onclick="{remove}" title="Удалить" type="button"><i class="fa fa-trash">{(selectedCount > 1) ? ⁗&nbsp;⁗ : ⁗⁗}</i><span class="badge" if="{selectedCount &gt; 1}">{selectedCount}</span></button>\n    </div>\n  </div>\n  <div class="table-responsive">\n    <div class="col-sm-12">\n      <datatable cols="{cols}" rows="{items}" handlers="{handlers}">\n        <datatable-cell each="{item, i in parent.parent.newCols}" name="{item.name}">{row.values[i].value}</datatable-cell>\n        <datatable-cell name="name" style="width: 60%;">{row.name}</datatable-cell>\n        <datatable-cell name="priceValue">\n          <input name="priceValue" min="-1000000" step="0.01" value="{row.priceValue}" onchange="{handlers.change}" type="{\'number\'}">\n        </datatable-cell>\n        <datatable-cell name="modificationId">\n          <select class="form-control" name="idModification" value="{row.idModification}" onchange="{handlers.changeselect}">\n            <option value="">Для всех</option>\n            <optgroup each="{mod in parent.parent.parent.opts.modifications}" label="{mod.name}">\n              <option each="{mi in mod.items}" value="{mi.id}" __selected="{row.idModification==mi.id}" no-reorder>{mi.values[0].value}</option>\n            </optgroup>\n          </select>\n        </datatable-cell>\n        <datatable-cell name="isDefault"><i class="fa fa-fw {row.isDefault ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.toggleCheckbox}"></i></datatable-cell>\n      </datatable>\n    </div>\n  </div>\n  <bs-pagination if="{value.items.length &gt; pages.limit}" name="paginator" onselect="{pages.change}" pages="{pages.count}" page="{pages.current}"></bs-pagination>\n', '', '', function(opts) {
'use strict';

var self = this;

self.items = [];

self.pages = {
    count: 0,
    current: 1,
    limit: 15,
    change: function change(e) {
        self.pages.current = e.currentTarget.page;
    }
};

self.getPageItems = function () {
    var count = self.value.items.length;

    self.pages.count = Math.ceil(count / self.pages.limit);

    if (self.pages.current > self.pages.count) {
        self.pages.current = self.pages.count;
    }

    self.pages.current = self.pages.current == 0 ? 1 : self.pages.current;

    var offset = (self.pages.current - 1) * self.pages.limit;
    var end = offset + self.pages.limit;

    var items = self.value.items.filter(function (item, i) {
        return i > offset - 1 && i < end;
    });

    return items;
};

self.сols = [{ name: 'name', value: 'Наименование' }, { name: 'priceValue', value: 'Цена' }, { name: 'isDefault', value: 'По умолчанию' }];

self.addValue = function () {
    modals.create('product-edit-option-values-add-modal', {
        type: 'modal-primary',
        columns: self.value.columns,
        submit: function submit() {
            var getIndexs = function getIndexs() {
                var counts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

                var count = counts.reduce(function (p, c) {
                    return p * c;
                });
                index = index > count ? count : index;
                var result = [];

                counts.reduceRight(function (p, c, i) {
                    result[i] = p % c;
                    return Math.floor(p / c);
                }, index);

                return result;
            };

            var getValues = function getValues(items, indexs) {
                return items.map(function (item, i) {
                    return item[indexs[i]];
                });
            };

            var items = [];

            if (this.tags.datatable instanceof Array) {
                this.tags.datatable.forEach(function (item) {
                    items.push(item.getSelectedRows());
                });
            } else {
                items.push(this.tags.datatable.getSelectedRows());
            }

            var counts = items.map(function (item) {
                return item.length;
            });
            var count = counts.reduce(function (p, c) {
                return p * c;
            });
            count = count > 1000 ? 1000 : count;

            for (var i = 0; i < counts.length; i++) {
                if (counts[i] == 0) {
                    popups.create({
                        style: 'popup-danger',
                        title: 'Ошибка',
                        text: 'Должны быть выбраны один или несколько пунктов в каждой категории',
                        timeout: 0
                    });
                    return;
                }
            }

            var _loop = function _loop(_i) {
                var indexs = getIndexs(counts, _i);
                var values = getValues(items, indexs);
                fl = false;

                self.value.items.forEach(function (item) {
                    if (item.idOptionValue == values[0].id) {
                        //console.log(item.idOptionValue, values[0].id)
                        //fl = true;
                    }
                });
                if (!fl) {
                    self.value.items.push({
                        name: values[0].name,
                        idOptionValue: values[0].id,
                        priceValue: values[0].price,
                        isDefault: 0
                    });
                }
            };

            for (var _i = 0; _i < count; _i++) {
                var fl;

                _loop(_i);
            }

            this.modalHide();
            self.update();
        }
    });
};

self.remove = function () {
    self.selectedCount = 0;

    var items = self.tags.datatable.getSelectedRows();

    self.value.items = self.value.items.filter(function (item) {
        return items.indexOf(item) === -1;
    });
};

self.handlers = {
    toggleCheckbox: function toggleCheckbox(e) {
        this.row.isDefault = !this.row.isDefault;
        this.update();
    },
    change: function change(e) {
        if (!e.target.name) return;

        var bannedTypes = ['checkbox', 'file', 'color', 'range', 'number'];

        if (e.target && bannedTypes.indexOf(e.target.type) === -1) {
            var selectionStart = e.target.selectionStart;
            var selectionEnd = e.target.selectionEnd;
        }

        if (e.target && e.target.type === 'checkbox' && e.target.name) e.item.row[e.target.name] = e.target.checked;
        if (e.target && e.target.type !== 'checkbox' && e.target.name) e.item.row[e.target.name] = e.target.value;
        if (e.currentTarget.tagName !== 'FORM' && e.currentTarget.name !== '') e.item.row[e.currentTarget.name] = e.currentTarget.value;

        if (e.target && bannedTypes.indexOf(e.target.type) === -1) {
            this.update();
            e.target.selectionStart = selectionStart;
            e.target.selectionEnd = selectionEnd;
        }
    },
    changeselect: function changeselect(e) {
        e.item.row.idModification = e.target.value;
    }
};

self.on('update', function () {
    if (opts.value) {
        if (self.value !== opts.value) self.selectedCount = 0;

        self.value = opts.value;
        self.items = self.getPageItems() || [];
    }
});

self.one('updated', function () {
    self.tags.datatable.on('row-selected', function (count) {
        self.selectedCount = count;
        self.update();
    });
});
});
riot.tag2('product-edit-options-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Опции</div>\n    </yield>\n    <yield to="body">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <label class="control-label">Группы</label>\n            <select class="form-control" name="idGroup" onclick="{parent.selectCategory}">\n              <option value="">Все</option>\n              <option each="{category, i in parent.optionCategories}" value="{category.id}" no-reorder>{category.name}</option>\n            </select>\n          </div>\n        </div>\n      </div>\n      <catalog object="Option" cols="{parent.cols}" remove="{parent.remove}" dblclick="{parent.opts.submit.bind(this)}" disablepagination="true" disable-col-select="true" reload="true" handlers="{parent.handlers}" before-success="{parent.opts.beforeSuccess}" store="product-edit-options-select-modal" filters="{parent.categoryFilters}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="type" style="width: 150px;">{row.groupName}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('remove');
self.collection = 'Options';
self.categoryFilters = false;
self.optionCategories = [];

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'groupName', value: 'Группа' }];
self.selectCategory = function (e) {
    var value = e.target.value;
    if (value) self.categoryFilters = [{ field: 'idGroup', sign: 'IN', value: value }];else self.categoryFilters = false;
    self.update();
    self.tags['bs-modal'].tags.catalog.reload();
};

self.getOptionGroup = function () {
    API.request({
        object: 'OptionGroup',
        method: 'Fetch',
        success: function success(response) {
            self.optionCategories = response.items;
            self.update();
        }
    });
};
self.getOptionGroup();
});
riot.tag2('product-edit-option-values-add-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить значения</div>\n    </yield>\n    <yield to="body">\n      <div each="{table, i in parent.items}">\n        <h4>{table.name}</h4>\n        <datatable cols="{table.cols}" rows="{table.items}">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n        </datatable>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">OK</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.columns = opts.columns || [];
self.items = [];
self.initCols = [{ name: 'id', value: '#', width: '60px' }];

var request = function request(index, id) {
    return function (callback) {
        API.request({
            object: 'OptionItems',
            method: 'Fetch',
            data: { filters: { field: 'idOption', value: id } },
            success: function success(response) {
                var _self$columns$index = self.columns[index],
                    name = _self$columns$index.id,
                    value = _self$columns$index.name;

                self.columns[index].items = response.items;
                self.columns[index].cols = self.initCols.concat([{ name: name, value: value }]);
                self.items[index] = self.columns[index];

                callback(null, 'success');
            },
            error: function error(response) {
                callback('error', null);
            }
        });
    };
};

self.on('mount', function () {
    var requests = self.columns.map(function (item, i) {
        return new request(i, item.id);
    });

    parallel(requests, function (err, res) {
        self.update();
    });
});
});


// WEBPACK FOOTER //
// ./pages/products/products/product-edit-options.tag